export const ICON_COLOR1 = "Color1";
export const ICON_COLOR2 = "Color2";
export const ICON_COLOR3 = "Color3";
export const ICON_COLOR4 = "Color4";
export const ICON_COLOR5 = "Color5";
export const ICON_COLOR6 = "Color6";
export const ICON_COLOR7 = "Color7";
export const ICON_COLOR8 = "Color8";
export const ICON_COLOR9 = "Color9";
export const ICON_COLOR10 = "Color10";
export const ICON_COLOR11 = "Color11";

export const ICON_COLOR_LIST = [
  ICON_COLOR1,
  ICON_COLOR2,
  ICON_COLOR3,
  ICON_COLOR4,
  ICON_COLOR5,
  ICON_COLOR6,
  ICON_COLOR7,
  ICON_COLOR8,
  ICON_COLOR9,
  ICON_COLOR10,
  ICON_COLOR11
];

export const DEFAULT_ICON_COLOR = ICON_COLOR11;

export const ICON_COLOR_MAPPING = {
  [ICON_COLOR1]: "--kf-color-secondary-one-500",
  [ICON_COLOR2]: "--kf-color-secondary-two-500",
  [ICON_COLOR3]: "--kf-color-secondary-three-500",
  [ICON_COLOR4]: "--kf-color-secondary-five-500",
  [ICON_COLOR5]: "--kf-color-secondary-four-500",
  [ICON_COLOR6]: "--kf-color-secondary-six-500",
  [ICON_COLOR7]: "--kf-color-secondary-seven-500",
  [ICON_COLOR8]: "--kf-color-secondary-eight-500",
  [ICON_COLOR9]: "--kf-color-secondary-nine-500",
  [ICON_COLOR10]: "--kf-color-secondary-ten-500",
  [ICON_COLOR11]: "--kf-color-gray-600"
};

export function parseDynamicColor(weight) {
  return {
    [ICON_COLOR1]: `--kf-color-secondary-one-${weight}`,
    [ICON_COLOR2]: `--kf-color-secondary-two-${weight}`,
    [ICON_COLOR3]: `--kf-color-secondary-three-${weight}`,
    [ICON_COLOR4]: `--kf-color-secondary-five-${weight}`,
    [ICON_COLOR5]: `--kf-color-secondary-four-${weight}`,
    [ICON_COLOR6]: `--kf-color-secondary-six-${weight}`,
    [ICON_COLOR7]: `--kf-color-secondary-seven-${weight}`,
    [ICON_COLOR8]: `--kf-color-secondary-eight-${weight}`,
    [ICON_COLOR9]: `--kf-color-secondary-nine-${weight}`,
    [ICON_COLOR10]: `--kf-color-secondary-ten-${weight}`,
    [ICON_COLOR11]: `--kf-color-gray-${weight}`
  };
}
